import React, { Component, Suspense } from "react";
import * as ReactDOM from "react-dom";
import Slider from "react-slick";
import edit from "../image/icons/edit.png";
import plus from "../image/icons/plus.png";
import InnerHTML from "dangerously-set-html-content";
import $ from "jquery";
const folderName = window.sessionStorage.getItem("homeName");
export default class Banner extends Component {  
  constructor(props) {
  super(props);
  this.state = {
    bannerData: [],
    sectionName: "Banner",
  };
}
componentDidMount() {
  const bannerData = JSON.parse(window.sessionStorage.getItem("Banner"));  
  if (bannerData) {
    this.setState({ bannerData: bannerData });
  } else {    
  }
}

addClick(sid, pId, cId, ptitle, cTitile, cdescri, childUrl, childImg, sOrder) {
  if($("#bannerParentId").val()!== "") {
    pId=$("#bannerParentId").val();
  }
  if(childImg){
    var splitImg=childImg.split("theme/")
    childImg=splitImg[1];
    }

  const LazyPage = React.lazy(() => import("../" + folderName + "/ThemeComponent"));
  ReactDOM.render(
    <div>
      <Suspense fallback={<div>Loading...</div>}>
        <section>
          <LazyPage
            sessionId={sid}
            parentId={pId}
            childId={cId}
            patentTitle={ptitle}
            childTitle={cTitile}
            childDesri={cdescri}
            sectionName={this.state.sectionName}
            childImg={childImg}
            sortSubOrder={sOrder}
          />
        </section>
      </Suspense>
    </div>,
    document.getElementById("bannerpopUpBlock")
  );
  $("#bannerpopUpBlock").addClass("editActive");
}

  render() {
    var settings = {
      dots: false,
      fade: true,
      infinite: true,
      autoplay: true,
      arrows: true,
      autoplaySpeed: 6000, 
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            swipe: true,
            dots: true
          }
        },
      ]
    };
    //const urlPath = window.location.origin.toString();
    return (
      <div class="banner-mainwapper" id="banner">
            {this.props.themeFlag === "theme" && (
          <div className="editIconSec" id="Banner">
            <span
              className="editIcon editAddIcon"
              title="Add"
              onClick={() => this.addClick("3","","","","","","","","")}
            >
              <img src={plus} alt="Add" />
            </span>
          </div>
        )}
        <div className="cmsContentDiv" id="bannerpopUpBlock"></div>
        <input type="hidden" id="bannerSectionId" value="3" />
        <div class="container">
        {this.state.bannerData.map((ban) => {
          return (
          <div>
        <input type="hidden" id="bannerParentId" value={ban.parentId} />
        {ban.sectionList.length !== "0" && (
            <Slider {...settings}>
            {ban.sectionList.map((data) => (
            <div class="banner-main row">
            {this.props.themeFlag === "theme" && (
            <div className="editIconSec">
                          <span
                            className="editIcon editAddIcon"
                            title="Edit"
                            onClick={() =>
                              this.addClick
                              (ban.sectionId,
                                ban.parentId,
                                data.childId,
                                ban.parentName,
                                data.childName,
                                data.childDescription,
                                data.childUrl,
                                data.childImage,
                                data.homeAdsSubSortOrder)
                            }
                          >
                            <img src={edit} alt="logo" />
                          </span>
                        </div>
                         )}
                    <div class="bannerContent col-lg-7">
                          {data.childName!=="@" ? (
                          <h1 className="banner-head"><InnerHTML html={data.childName} /></h1>
                          ) : ''}
                          <img src={data.childImage} alt="banner" className="img-fluid my-3 mob-show"/>
                          {/* <p className="bannerContent-text">{data.childDescription}</p> */}
                          <p className="bannerContent-text"><InnerHTML html={data.childDescription} /></p>
                          <p>
                          <a href="home/doctor-list-main/0">
                            <span class="bannerButton">Book Appointment</span>
                          </a>
                          </p>
                      </div>
                    <div className="bannerImageDiv col-lg-5 web-show">
                        <img src={data.childImage} alt="banner " className="img-fluid"/>
                    </div>
                </div>
                ))}
            </Slider>
            )}
            </div>
         );
        })}
        </div>
      </div>
    );
  }
}
